import EditLabelsModal from './EditLabelsModal';
export default EditLabelsModal;
